import React from 'react';
import TablaDoc from './TablaDoc';

/**
 * Tareas del día por persona, en formato tabla: quién, qué hacer hoy con qué
 * negocios, sobre qué se le hace coaching y qué se le exige en la semana.
 */
const ChecklistConsultores = ({ checklist, t }) => {
  const columnas = [
    {
      label: t('ap_colConsultant'),
      ancho: '22%',
      render: (k) => (
        <>
          <strong>{k.consultor}</strong>
          <span className='ap-doc-sec'>
            {k.negocios_perdidos} {t('ap_lost')} · {k.negocios_evitables}{' '}
            {t('ap_avoidable')}
          </span>
          <span className='ap-doc-sec'>
            {t('ap_closeScore')} {k.score_cierre_prom}/4 · {t('ap_followScore')}{' '}
            {k.score_seguimiento_prom}/4
          </span>
        </>
      ),
    },
    {
      label: t('ap_colTodayTasks'),
      ancho: '34%',
      render: (k) => {
        const bloques = [
          {
            clave: 'compliance',
            etiqueta: `${t('ap_complianceTag').toUpperCase()} (${
              k.compliance_casos
            })`,
            nota: k.nota_compliance,
            ids: k.compliance_deal_ids,
            clase: 'ap-doc-tipo',
          },
          {
            clave: 'urgentes',
            etiqueta: `${t('ap_resumeToday')} (${k.recuperables_urgentes_casos})`,
            ids: k.recuperables_urgentes_deal_ids,
            clase: 'ap-doc-limite',
          },
          {
            clave: 'crm',
            etiqueta: `${t('ap_fixInCrm')} (${k.verificar_crm_casos})`,
            nota: k.nota_crm,
            ids: k.verificar_crm_deal_ids,
          },
        ].filter((b) => (b.ids ?? []).length > 0);

        if (bloques.length === 0) {
          return <span className='ap-doc-sec'>{t('ap_noTasks')}</span>;
        }

        return bloques.map((b) => (
          <div key={b.clave} className='ap-doc-tarea'>
            <strong className={b.clase}>{b.etiqueta}</strong>
            {b.nota && <span className='ap-doc-parrafo'>{b.nota}</span>}
            <span className='ap-doc-ids'>{b.ids.join(', ')}</span>
          </div>
        ));
      },
    },
    {
      label: t('ap_coaching'),
      ancho: '24%',
      render: (k) => (
        <>
          <strong>{k.coaching_paso_protocolo}</strong>
          {k.coaching_detalle && (
            <span className='ap-doc-parrafo'>{k.coaching_detalle}</span>
          )}
        </>
      ),
    },
    {
      label: t('ap_thisWeek'),
      ancho: '20%',
      render: (k) => k.exigencia_semana ?? '',
    },
  ];

  return (
    <TablaDoc
      columnas={columnas}
      filas={checklist?.consultores ?? []}
      textoVacio={t('ap_noRows')}
    />
  );
};

export default ChecklistConsultores;
